import apiSlice from '../apiSlice';

import type { UserInfo } from '@/features/users';

const USERS_API_URL = '/api/users';

const usersTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['user'],
});

const usersApiSlice = usersTags.injectEndpoints({
  endpoints: (builder) => ({
    getUserInfo: builder.query<UserInfo, null>({
      query: () => ({
        url: `${USERS_API_URL}/details/`,
        method: 'GET',
      }),
      providesTags: [{ type: 'user', id: 'GLOBAL_FILTERS' }],
    }),

    selectPartner: builder.mutation<{ selectedPartner: string }, string>({
      query: (partnerId) => ({
        url: `${USERS_API_URL}/select-partner/`,
        method: 'PUT',
        data: { partnerId },
      }),
      invalidatesTags: [{ type: 'user', id: 'GLOBAL_FILTERS' }],
    }),

    selectPlatform: builder.mutation<{ selectedPlatform: string }, string>({
      query: (platformId) => ({
        url: `${USERS_API_URL}/select-platform/`,
        method: 'PUT',
        data: { platformId },
      }),
      invalidatesTags: [{ type: 'user', id: 'GLOBAL_FILTERS' }],
    }),

    selectAdvertiser: builder.mutation<{ selectedAdvertiser: string }, string>({
      query: (advertiserId) => ({
        url: `${USERS_API_URL}/select-advertiser/`,
        method: 'PUT',
        data: { advertiserId },
      }),
      invalidatesTags: [{ type: 'user', id: 'GLOBAL_FILTERS' }],
    }),

    selectAccount: builder.mutation<{ selectedAccount: string }, string>({
      query: (accountId) => ({
        url: `${USERS_API_URL}/select-account/`,
        method: 'PUT',
        data: { accountId },
      }),
      invalidatesTags: [{ type: 'user', id: 'GLOBAL_FILTERS' }],
    }),
  }),
});

export const {
  useGetUserInfoQuery,
  useSelectPartnerMutation,
  useSelectPlatformMutation,
  useSelectAdvertiserMutation,
  useSelectAccountMutation,
} = usersApiSlice;

export default usersApiSlice;
